import {JSX} from 'react';
import Weather from '../weather/weather';
import Clock from '../clock/clock';
import './clockWeatherPreview.css'

const ClockWeatherPreview = () : JSX.Element => {
    return (
        <div className='clockWeather-preview-container'>
            <Weather/>
            <div className='clocks-container'>
                <Clock/>
                <div className='smaller-clcok'>
                    <Clock timeZone={'America/Los_Angeles'} smallerSize={true}/>
                </div>
            </div>
        </div>
    )
};

export default ClockWeatherPreview;